export class IUserDepartment {   
    email : string;
    userDepartments : IDepartment[];
    constructor(){}
}

export class IDepartment {   
    department : string;
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/user-department/user-department.model.ts